import { getAccessToken, subscribeToAccessToken } from "./session-store";

export type AuthStatus = "restoring" | "session" | "legacy" | "mock" | "signed_out" | "unavailable";

let status: AuthStatus = "restoring";
const listeners = new Set<() => void>();

export function getAuthStatus(): AuthStatus {
  return status;
}

export function setAuthStatus(next: AuthStatus) {
  if (next === status) {
    return;
  }
  status = next;
  for (const listener of listeners) {
    listener();
  }
}

export function subscribeToAuthStatus(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function isSignedIn(value: AuthStatus): boolean {
  return value === "session" || value === "legacy" || value === "mock";
}

export function handleUnauthorizedResponse() {
  if (getAccessToken() === null && isSignedIn(status)) {
    setAuthStatus("signed_out");
  }
}

subscribeToAccessToken(() => {
  if (getAccessToken() !== null) {
    setAuthStatus("session");
  } else if (status === "session") {
    setAuthStatus("signed_out");
  }
});
